export const CHECKOUT_CURRENT_STEP = 'CHECKOUT_CURRENT_STEP'
